<template>
  <div>
    <Table
      resource="Transaction"
      :actions="actions"
      :items="$store.getters['transaction/tableData']"
      :detail="$store.getters['transaction/detailData']"
      :fields="$store.getters['transaction/tableFields']"
      :pagination="$store.state.transaction.tablePagination"
      :keyword="$store.state.transaction.tableKeyword"
      :loading="$store.state.transaction.loadingTable"
      :filter="$store.state.transaction.tableFilter"
      :sort="$store.state.transaction.tableSort"
      :sort-options="sortOptions"
      :tab-options="tabOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'view',
      ],

      // Tabs
      tabOptions: [
        { key: 'status', label: 'Semua' },
        {
          key: 'status', label: 'Belum Dibayar', value: 'pending',
        },
        {
          key: 'status', label: 'Diproses', value: 'process', default: true,
        },
        { key: 'status', label: 'Dikirim', value: 'picked_up' },
        { key: 'status', label: 'Sampai', value: 'arrived' },
        { key: 'status', label: 'Selesai', value: 'completed' },
        { key: 'status', label: 'Dibatalkan', value: 'cancelled' },
        { key: 'status', label: 'Ditolak', value: 'rejected' },
        { key: 'status', label: 'Tidak Dibayar', value: 'expired' },
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('transaction/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('transaction/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('transaction/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('transaction/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('transaction/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('transaction/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('transaction/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('transaction/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('transaction/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('transaction/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
